"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDirectDebitAmountUIV2 = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../shared/core");
var components_1 = require("../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../analytics-subjects");
var components_2 = require("../../../components");
var constants_1 = require("../../../constants");
var copy_1 = require("../../../copy");
var data_1 = require("../../../data");
var section_ids_1 = require("../../../section-ids");
var utils_1 = require("../../../utils");
var components_3 = require("./components");
var RecommendationExplanation_1 = require("./components/RecommendationExplanation/RecommendationExplanation");
var DirectDebitOptions;
(function (DirectDebitOptions) {
    DirectDebitOptions["RECOMMENDED"] = "recommended_DD";
    DirectDebitOptions["COVID_HARDSHIP_SCHEME"] = "covid-scheme";
    DirectDebitOptions["OTHER"] = "other";
})(DirectDebitOptions || (DirectDebitOptions = {}));
var ChangeDirectDebitAmountUIV2 = function (_a) {
    var _b, _c;
    var _d, _e, _f, _g, _h, _j, _k;
    var customerId = _a.customerId, accountId = _a.accountId, paymentDetails = _a.paymentDetails, apiErrorCode = _a.apiErrorCode;
    var navigate = (0, ui_tools_1.useNavigate)();
    var _l = (0, core_1.useLinks)(), payments = _l.payments, updateDirectDebitAmountConfirmation = _l.updateDirectDebitAmountConfirmation;
    var search = window.location.search;
    var amountFromParams = (0, core_1.getValueFromQueryParams)('amount', search);
    var _m = (0, core_1.useComponents)(), CurrencyField = _m.CurrencyField, PrimaryCTAButton = _m.PrimaryCTAButton, ErrorNotification = _m.ErrorNotification, Card = _m.Card, Heading1 = _m.Heading1, Stack = _m.Stack, ButtonGroup = _m.ButtonGroup;
    var _o = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _o.Copy, copy = _o.copy;
    var currencyCode = core_1.configService.getConfig().retailer.currencyCode;
    var _p = __read((0, react_1.useState)(false), 2), apiError = _p[0], setApiError = _p[1];
    var directDebitAmount = ((_d = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _d === void 0 ? void 0 : _d.amount) || undefined;
    var numericRecommendedDirectDebit = (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentRecommendation)
        ? Number(paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentRecommendation.roundedRecommendationAmount)
        : 0;
    var paramAmount = (0, utils_1.getDefaultAmount)(amountFromParams);
    var minimumDD = (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentRecommendation)
        ? (0, utils_1.getMinimumRecommendedAmount)(paymentDetails.paymentRecommendation)
        : ((_e = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _e === void 0 ? void 0 : _e.amount)
            ? Number(paymentDetails.paymentSchedule.amount)
            : constants_1.MIN_DD_AMOUNT;
    var _q = __read((0, react_1.useState)(paramAmount ? paramAmount : minimumDD.toString()), 2), amount = _q[0], setAmount = _q[1];
    var _r = __read((0, react_1.useState)([]), 2), errors = _r[0], setErrors = _r[1];
    var errorRef = (0, react_1.createRef)();
    var _s = (0, data_1.useChangePaymentAmount)({ customerId: customerId, accountId: accountId }), directDebitAmountMutation = _s.mutate, loading = _s.loading;
    var miniumDirectDebitAmount = (0, core_1.major0DP)((0, core_1.majorToMinor)(minimumDD));
    var handleAmountChange = function (_a) {
        var value = _a.currentTarget.value;
        setAmount(value);
    };
    var analyticsPropsRaw = {
        recommendedDirectDebit: numericRecommendedDirectDebit,
        currentDirectDebit: directDebitAmount ? directDebitAmount : null,
    };
    var handleSubmit = function (event) {
        var _a, _b;
        event.preventDefault();
        setErrors([]);
        if (loading) {
            return;
        }
        var numericAmount = Number(amount);
        var isInRange = (0, utils_1.isAmountInRange)(amount, Number(minimumDD));
        if (!isInRange || !Number.isInteger(numericAmount)) {
            setErrors([
                {
                    id: 'amount',
                    message: copy('changeDirectDebitErrorRange', {
                        minimumDD: miniumDirectDebitAmount,
                        maximumDD: (0, core_1.major0DP)((0, core_1.majorToMinor)(constants_1.MAX_DD_AMOUNT)),
                    }),
                },
            ]);
        }
        else if (directDebitAmount &&
            numericAmount === Number(directDebitAmount)) {
            setErrors([
                {
                    id: 'amount',
                    message: copy('changeDirectDebitErrorSameValue'),
                },
            ]);
        }
        else {
            directDebitAmountMutation({
                paymentScheduleId: ((_a = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _a === void 0 ? void 0 : _a.id)
                    ? paymentDetails.paymentSchedule.id
                    : undefined,
                amount: { value: amount, currency: currencyCode },
                scheduleDay: ((_b = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _b === void 0 ? void 0 : _b.day) || 1, // day of month will always be defined in Kapi
            }, {
                onCompleted: function () {
                    var _a;
                    navigate({
                        pathname: updateDirectDebitAmountConfirmation(),
                        search: "?".concat((0, utils_1.createConfirmParamsKapi)({
                            amount: amount,
                            scheduleDay: ((_a = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _a === void 0 ? void 0 : _a.day) || 1,
                        })),
                    });
                },
                onError: function () {
                    setApiError(true);
                },
            });
        }
    };
    var errorCode = apiErrorCode || (0, utils_1.getErrorCode)(paymentDetails);
    return (react_1.default.createElement("section", { "data-testid": section_ids_1.CHANGE_DD_AMOUNT_SECTION_ID },
        apiError ? (react_1.default.createElement(ErrorNotification, { id: section_ids_1.CHANGE_DIRECT_DEBIT_AMOUNT_SUBMIT_ERROR, ref: errorRef },
            react_1.default.createElement(Copy, { copyKey: "updateDirectDebitAmountErrorGeneric" }))) : null,
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CHANGE_DD_AMOUNT_CANCEL_BUTTON, properties: __assign(__assign({}, analyticsPropsRaw), (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b)) },
                    react_1.default.createElement(components_1.Breadcrumb, { "data-testid": "breadcrumb", href: payments() }, react_1.default.createElement(Copy, { copyKey: "backtoPaymentsBreadcrumb" }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Heading1, null,
                        react_1.default.createElement(Copy, { copyKey: "changeDirectDebitHeading" })),
                    ((_f = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _f === void 0 ? void 0 : _f.method) &&
                        ((_g = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _g === void 0 ? void 0 : _g.day) &&
                        ((_h = paymentDetails.paymentSchedule) === null || _h === void 0 ? void 0 : _h.digits) && (react_1.default.createElement("div", { "data-testid": "current-payment-details" },
                        react_1.default.createElement(Copy, { copyKey: paymentDetails.paymentSchedule.method === 'CARD'
                                ? 'regularPaymentSummaryCardBody'
                                : 'regularPaymentSummaryBankBody', values: {
                                amount: (0, core_1.major2DP)((0, core_1.majorToMinor)(Number(paymentDetails.paymentSchedule.amount))),
                                day: (0, utils_1.withOrdinal)(paymentDetails.paymentSchedule.day),
                                digits: paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule.digits,
                            } })))),
                (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentRecommendation) &&
                    directDebitAmount &&
                    !errorCode && (react_1.default.createElement(components_3.RecommendedMessage, { currentPaymentAmount: Number(directDebitAmount), recommendedPaymentAmount: minimumDD })),
                errorCode ? (react_1.default.createElement(components_2.ErrorState, { error: errorCode, type: "Amount" })) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("form", { onSubmit: handleSubmit },
                        react_1.default.createElement(Stack, { spaceBetween: [3, 6] },
                            react_1.default.createElement(CurrencyField, { currency: ((_j = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _j === void 0 ? void 0 : _j.currency) === 'AUD'
                                    ? 'AUD'
                                    : undefined, "data-testid": "currency-field-change-dd", label: copy('changeDirectDebitCurrencyFieldLabel'), id: "amount", value: amount, disabled: loading, onChange: handleAmountChange, error: (0, nebula_1.getErrorMessage)('amount', errors), hint: (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentRecommendation)
                                    ? copy('changeDirectDebitCurrencyFieldHintMinPayment', {
                                        miniumDirectDebitAmount: miniumDirectDebitAmount,
                                    })
                                    : copy('changeDirectDebitCurrencyFieldHintOnTrack', {
                                        miniumDirectDebitAmount: miniumDirectDebitAmount,
                                    }), min: minimumDD, max: constants_1.MAX_DD_AMOUNT, characters: 8 }),
                            react_1.default.createElement(ButtonGroup, null,
                                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CHANGE_DD_AMOUNT_BUTTON, properties: __assign(__assign({}, analyticsPropsRaw), (_c = {}, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c.amount = amount, _c.selectedMode = Number(amount) > minimumDD
                                        ? DirectDebitOptions.OTHER
                                        : DirectDebitOptions.RECOMMENDED, _c)) },
                                    react_1.default.createElement(PrimaryCTAButton, { "data-testid": "change-dd-button", onClick: handleSubmit, loading: loading },
                                        react_1.default.createElement(Copy, { copyKey: "changeDirectDebitChangeDdButton" })))))),
                    (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentRecommendation) &&
                        ((_k = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _k === void 0 ? void 0 : _k.amount) ? (react_1.default.createElement("div", { "data-testid": "recommendation-explanation" },
                        react_1.default.createElement(RecommendationExplanation_1.RecommendationExplanation, null))) : null))))));
};
exports.ChangeDirectDebitAmountUIV2 = ChangeDirectDebitAmountUIV2;
